import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-data-roaming-ui',
  templateUrl: 'data-roaming.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsDataRoamingComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly dataRoaming = output<boolean>();

  public readonly dataRoamingForm = this.fb.group({
    dataRoamingEnabled: [false],
  });

  get dataRoamingEnabled() {
    return this.dataRoamingForm.get('dataRoamingEnabled') as UntypedFormControl;
  }

  onSubmit() {
    this.dataRoaming.emit(this.dataRoamingEnabled.value);
  }
}
